var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 17.1699H32.125M13.375 24.6699H22.75M39.625 37.7949L33.3919 34.6783C32.9194 34.442 32.6832 34.3239 32.4355 34.2407C32.2157 34.1668 31.9894 34.1134 31.7598 34.0811C31.501 34.0449 31.2368 34.0449 30.7086 34.0449H11.875C9.77479 34.0449 8.7247 34.0449 7.92254 33.6362C7.21692 33.2767 6.64324 32.703 6.28373 31.9974C5.875 31.1953 5.875 30.1451 5.875 28.0449V13.7949C5.875 11.6947 5.875 10.6446 6.28373 9.84246C6.64324 9.13684 7.21692 8.56317 7.92254 8.20365C8.7247 7.79492 9.77481 7.79492 11.875 7.79492H33.625C35.7252 7.79492 36.7754 7.79492 37.5775 8.20365C38.2831 8.56317 38.8568 9.13684 39.2162 9.84246C39.625 10.6446 39.625 11.6947 39.625 13.7949V37.7949Z",
    stroke: "#194775",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.8b826b892d7935dedfb9630647ed7489.svg";
export { ForwardRef as ReactComponent };